import { render, staticRenderFns } from "./ProjectionTable.vue?vue&type=template&id=5663faec&scoped=true"
import script from "./ProjectionTable.vue?vue&type=script&lang=js"
export * from "./ProjectionTable.vue?vue&type=script&lang=js"
import style0 from "./ProjectionTable.vue?vue&type=style&index=0&id=5663faec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5663faec",
  null
  
)

export default component.exports